"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iterator_to_map_1 = require("./iterator-to-map");
function merge(iterable1, iterable2) {
    let result = new Map();
    let index = 0;
    let map1 = iterable1 ? iterator_to_map_1.iteratorToMap(iterable1) : null;
    let map2 = iterable2 ? iterator_to_map_1.iteratorToMap(iterable2) : null;
    if (map1 === null || map2 === null) {
        return null;
    }
    for (let [key, value] of map1) {
        if (typeof key === 'number') {
            key = index++;
        }
        result.set(key, value);
    }
    for (let [key, value] of map2) {
        if (typeof key === 'number') {
            key = index++;
        }
        result.set(key, value);
    }
    if (Array.isArray(iterable1)) {
        return [...result.values()];
    }
    return result;
}
exports.merge = merge;
